import React from 'react';

const NotApplicable = () => <div>Not Applicable</div>;

export default NotApplicable;
